import { ReactNode } from "react";

export const ContentCard = ({
  children,
  title,
  headerRight,
}: {
  children: ReactNode;
  title: string;
  headerRight?: ReactNode;
}) => (
  <div className="bg-white rounded">
    <div className="flex items-center justify-between gap-medium h-[4.8rem] px-[2.4rem] border-b border-neutral-100">
      <div className="flex items-center min-w-0 h-[4.8rem] border-b-2 border-neutral-500">
        <h3 className="text-paragraph font-semibold">{title}</h3>
      </div>
      {headerRight}
    </div>
    <div className="border-b border-neutral-100 rounded-b">{children}</div>
  </div>
);
